<app-pagetoolbar icon="event_note" label="News Items"> </app-pagetoolbar>
<div class="news-items-container">
  <app-newsitem-card *ngFor="let i of newsitems" [item]="i" [readonly]="false" (itemDeleted)="removeNewsItem($event)"></app-newsitem-card>
</div>

<button *ngIf="canAddNewsItem$ | async" id="new-newsitems" (click)="addNewsItem()" mat-fab>
  <mat-icon>post_add</mat-icon>
</button>
